import Vue from 'vue'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/utils/event-bus.js